import React, { useState } from 'react';
import { getAuth, GoogleAuthProvider, signInWithPopup, signInWithCredential, signInWithEmailAndPassword, createUserWithEmailAndPassword,fetchSignInMethodsForEmail } from 'firebase/auth';
import { doc, setDoc, getDoc, Timestamp } from "firebase/firestore";
import { auth, provider, db } from "../../firebase_service/firebase";

import { useNavigate } from 'react-router-dom';
import '../../css/components/Login.css';

const WebPage_Login = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState('');
  const [password, setPassword] = useState('');
  const [name, setName] = useState('');
  const [isSignUp, setIsSignUp] = useState(false);
  const [rePassword, setRePassword] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const [showRePassword, setShowRePassword] = useState(false);

  const [isLoading, setIsLoading] = useState(false);

  const extId = process.env.REACT_APP_EXTENSION_ID;

  const handleGoogleLogin = async () => {
    try {
      setIsLoading(true);
      await signInWithPopup(auth, provider);
      setIsLoading(false);
      navigate('/');
    } catch (error) {
      setIsLoading(false);
      alert("Google login failed: " + error.message);
    }
  };

  const handleEmailPasswordLogin = async (currentemail, currentpassword) => {
    try {
      setIsLoading(true);

      currentemail = currentemail.trim();
      currentpassword = currentpassword.trim();

      if (!currentemail || !currentpassword) {
        setIsLoading(false);
        alert('Email and password cannot be empty.');
        return;
      }
      try {
        const methods = await fetchSignInMethodsForEmail(auth, currentemail);

        if (methods.includes("google.com")) {
          setIsLoading(false);
          alert("This email is registered with Google Sign-In, login with Google Sign-In instead.");
          return;
        }
      } catch (error) {
        setIsLoading(false);
        alert("Login failed.");
        return;
      }


      try {
        await signInWithEmailAndPassword(auth, currentemail, currentpassword);
      } catch (error) {
        setIsLoading(false);
        var errorMessage = "Invalid email or password";
        if (error.message.includes("invalid-credential")) {
          setIsLoading(false);
          alert("Invalid email or password or your account already login through google.");
          return;
        }
        if (error.code === 'auth/user-not-found') {
          errorMessage = "User not found. Please check your email.";
        } else if (error.code === 'auth/wrong-password') {
          errorMessage = "Incorrect password. Please try again.";
        } else if (error.code === 'auth/invalid-email') {
          errorMessage = "Invalid email address.";
        }
        setIsLoading(false);
        alert(errorMessage);
        return;
      }
      setIsLoading(false);
      // Redirect to the main page after successful email/password login
      navigate('/');

    } catch (error) {
      setIsLoading(false);
      alert(`Login failed`);
    }
  };

  const handleEmailPasswordSignUp = async (email, password, rePassword) => {

    setIsLoading(true);
    // Trim the name and email valu
    let current_email = email.trim();
    let current_password = password.trim();
    let current_rePassword = rePassword.trim();

    const nameRegex = /^[a-zA-Z0-9\s!@#$%^&*()_+\-=\[\]{};':"\\|,.<>\/?]{3,15}$/;
    if (!nameRegex.test(name)) {
      setIsLoading(false);
      alert('Name must be between 3 and 15 characters, and contain only text or special characters (no emojis).');
      return;
    }



    if (!current_email || !current_password || !current_rePassword) {
      setIsLoading(false);
      alert('Email and password cannot be empty.');
      return;
    }

    if (current_password.length < 6) {
      setIsLoading(false);
      alert('Password should be at least 6 characters.');
      return;
    }



    if (current_password !== current_rePassword) {
      setIsLoading(false);
      alert('Passwords do not match.');
      return;
    }

    try {
      const signInMethods = await fetchSignInMethodsForEmail(auth, email);



      if (signInMethods.includes("google.com")) {
        setIsLoading(false);
        alert("This email is registered with Google Sign-In, login with Google Sign-In instead.");
        return;
      }

      if (signInMethods.includes("password")) {
        setIsLoading(false);
        alert("This email is already registered with Email/Password.please login");
        return;
      }

      const result = await createUserWithEmailAndPassword(auth, email, password);
      const user = result.user;

      const userRef = doc(db, "users", user.uid);
      const userSnap = await getDoc(userRef);

      const now = Timestamp.now();
      const jsDate = now.toDate(); // Convert Firestore Timestamp to JS Date

      // Extract year and month
      const year = jsDate.getFullYear();
      const month = jsDate.getMonth(); // 0 = Jan, 1 = Feb, ..., 11 = Dec

      // Create start date: 1st of current month at 00:00
      const start_date = Timestamp.fromDate(new Date(year, month, 1, 0, 0, 0));

      // Create end date: last day of current month at 23:59:59
      const lastDay = new Date(year, month + 1, 0).getDate(); // Get last day of current month
      const end_date = Timestamp.fromDate(new Date(year, month, lastDay, 23, 59, 59));

      if (!userSnap.exists()) {

        await setDoc(userRef, {
          uid: user.uid,
          username: name, // Use the 'name' state variable
          email: user.email,
          photoURL: null,
          createdAt: Timestamp.now(),
          lastLoginAt: Timestamp.now(),
          // Add other fields as necessary
          subscription: {
            start_date: start_date,
            end_date: end_date,
            plan: "free",
            status: "active",
            payment_history: []
          },
          usage: {
            monthly_searches: 0,
            total_searches: 0,
            monthly_snippets: 0,
            total_snippets: 0,
            monthly_tags: 0,
            total_tags: 0,
          }
        });
      }
      setIsLoading(false);
      alert("Sign up successful! Please login.");
      setIsSignUp(false); // Switch to login form after successful sign up

    } catch (error) {
      setIsLoading(false);
      alert(`Sign up failed: ${error.message}`);
    }
  };

  return (
    <div className="login-bg">
       <div className="login-card">
         <h1 className="login-title">{isSignUp ? 'Sign Up' : 'Login'}</h1>
         <form className="login-form" onSubmit={(e) => {
           e.preventDefault();
           if (isSignUp) {
             handleEmailPasswordSignUp(email, password, rePassword);
           } else {
             handleEmailPasswordLogin(email, password);
           }
         }}>
           <input
             type="email"
             className="login-input"
             placeholder="Email"
             value={email}
             onChange={(e) => setEmail(e.target.value)}
             required
           />
           {isSignUp && (
             <input
               type="text"
               className="login-input"
               placeholder="Name"
               value={name}
               onChange={(e) => setName(e.target.value)}
               required
             />
           )}
           <div className="password-input-container">
             <input
               type={showPassword ? "text" : "password"}
               className="login-input"
               placeholder="Password"
               value={password}
               onChange={(e) => setPassword(e.target.value)}
               required
             />
             <span className="password-toggle" onClick={() => setShowPassword(!showPassword)}>
               {showPassword ? 'Hide' : 'Show'}
             </span>
           </div>
           {isSignUp && (
             <div className="password-input-container">
               <input
                 type={showRePassword ? "text" : "password"}
                 className="login-input"
                 placeholder="Re-enter Password"
                 value={rePassword}
                 onChange={(e) => setRePassword(e.target.value)}
                 required
               />
               <span className="password-toggle" onClick={() => setShowRePassword(!showRePassword)}>
                 {showRePassword ? 'Hide' : 'Show'}
               </span>
             </div>
           )}
           <button type="submit" className="login-button" disabled={isLoading}>
             {isLoading ? 'Loading...' : (isSignUp ? 'Sign Up' : 'Login')}
           </button>
         </form>
         <p className="login-toggle">
           {isSignUp ? 'Already have an account? ' : 'Don\'t have an account? '}
           <span onClick={() => setIsSignUp(!isSignUp)}>{isSignUp ? 'Login' : 'Sign Up'}</span>
         </p>
         <div className="login-separator">OR</div>
         <div className="login-btn">
           <button onClick={handleGoogleLogin} className="login-button google-login-button">
              <svg width="18" height="18" viewBox="0 0 18 18" xmlns="http://www.w3.org/2000/svg">
                <path d="M17.64 9.2045c0-.638-.057-1.252-.164-1.845H9v3.481h4.844c-.209 1.142-.84 2.103-1.784 2.757v2.259h2.909c1.701-1.566 2.683-3.877 2.683-6.652z" fill="#4285F4"/>
                <path d="M9 18c2.43 0 4.467-.806 5.956-2.18L12.05 13.56c-.806.54-1.83.86-3.05.86-2.344 0-4.328-1.584-5.036-3.711H1.96v2.332C3.51 16.152 6.08 18 9 18z" fill="#34A853"/>
                <path d="M3.964 10.71c-.18-.54-.282-1.117-.282-1.71s.102-1.17.282-1.71V4.958H1.96A8.998 8.998 0 000 9c0 1.452.348 2.827.956 4.018l3.008-2.308z" fill="#FBBC05"/>
                <path d="M9 3.58c1.324 0 2.508.454 3.44 1.345l2.582-2.582C13.463.891 11.426 0 9 0 6.08 0 3.51 1.848 1.96 4.958L3.964 7.29C4.672 5.163 6.656 3.58 9 3.58z" fill="#EA4335"/>
              </svg>
              Sign in with Google
            </button>
         </div>
       </div>
     </div>
  );
};

export default WebPage_Login;

